module.exports = __webpack_public_path__ + "img/xilofono-tigre.8a2c649f.jpg";